package com.evoapps.evoshift.ui.user

import androidx.compose.ui.platform.testTag
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.runtime.getValue
import androidx.compose.animation.animateColorAsState
import com.evoapps.evoshift.ui.theme.motionTween
import com.evoapps.evoshift.ui.theme.animatedFraction
import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.ui.util.formatPercentOrDash
import com.evoapps.evoshift.ui.util.labourPercentLabelRes
import com.evoapps.evoshift.ui.util.labourValueRes
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.LocalContextSwitcher
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.ui.finance.formatSpmhOrDash
import evoshift.composeapp.generated.resources.spmh
import evoshift.composeapp.generated.resources.statistics_title
import com.evoapps.evoshift.ui.notifications.NotificationsBell
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_select_workplace
import evoshift.composeapp.generated.resources.dashboard_switch
import evoshift.composeapp.generated.resources.dashboard_workplace_fallback
import evoshift.composeapp.generated.resources.financials_actual_to_date
import evoshift.composeapp.generated.resources.financials_comparison
import evoshift.composeapp.generated.resources.financials_cost_breakdown
import evoshift.composeapp.generated.resources.financials_empty
import evoshift.composeapp.generated.resources.financials_fixed_costs
import evoshift.composeapp.generated.resources.financials_health
import evoshift.composeapp.generated.resources.financials_labor_costs
import evoshift.composeapp.generated.resources.financials_estimate_note
import evoshift.composeapp.generated.resources.financials_other_costs
import evoshift.composeapp.generated.resources.financials_roster
import evoshift.composeapp.generated.resources.financials_select_roster
import evoshift.composeapp.generated.resources.financials_total_expenses
import evoshift.composeapp.generated.resources.planned
import evoshift.composeapp.generated.resources.revenue
import evoshift.composeapp.generated.resources.financials_show_daily_records
import evoshift.composeapp.generated.resources.financials_show_payroll
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.ResponsiveColumns
import com.evoapps.evoshift.ui.adaptive.handCursor
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.BarChart
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.TrendingDown
import androidx.compose.material.icons.filled.TrendingUp
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.FinancialSummary
import com.evoapps.evoshift.domain.explain.Calculation
import com.evoapps.evoshift.domain.explain.Side
import com.evoapps.evoshift.ui.finance.ExplainableAmount
import com.evoapps.evoshift.ui.finance.LocalExplainNames
import com.evoapps.evoshift.domain.model.FixedCost
import com.evoapps.evoshift.ui.finance.DeleteOneOffCostDialog
import com.evoapps.evoshift.ui.finance.MonthCostsSection
import com.evoapps.evoshift.ui.finance.MonthlyResultCard
import com.evoapps.evoshift.ui.finance.MissingPayBanner
import com.evoapps.evoshift.viewmodels.MissingPayScope
import evoshift.composeapp.generated.resources.financials_labor_costs_note
import com.evoapps.evoshift.ui.finance.OneOffCostDialog
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.FinancialsEvent
import com.evoapps.evoshift.viewmodels.FinancialsViewModel
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.LocalOnColours
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.*
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.nav_financials
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.di.diViewModel

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FinancialsScreen(
    onNavigateToProfile: () -> Unit,
    onNavigateToDailyRecords: (String, String) -> Unit,
    onNavigateToPayroll: (String) -> Unit,
    onCreateNewWorkplace: () -> Unit,
    onNavigateToWorkplaceSettings: (String) -> Unit,
    /** Null at the Money tab; reached from More, it has a back arrow (SH-110). */
    onNavigateBack: (() -> Unit)? = null,
    /** SH-228: the bar's "Statystyki": the workplace and a day of the month on screen ("YYYY-MM-DD"). */
    onNavigateToStatistics: (workplaceId: String, anchor: String?) -> Unit = { _, _ -> },
    /** SH-257: "Godziny pracy" (confirming the actual hours) of the workplace. */
    onNavigateToWorkHours: (workplaceId: String) -> Unit = {},
) {
    // One view model per screen entry (by di.instance() built a new one on every recomposition).
    val viewModel: FinancialsViewModel = diViewModel()
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    val contextSwitcher = LocalContextSwitcher.current
    var addingCost by remember { mutableStateOf(false) }
    var editingCost by remember { mutableStateOf<FixedCost?>(null) }
    var deletingCost by remember { mutableStateOf<FixedCost?>(null) }

    // Saves and their failures, once the month's figures are on screen (an empty month shows its
    // error in place).
    val snackbarHostState = remember { SnackbarHostState() }
    val messageText = (uiState.successMessage ?: uiState.error?.takeIf { uiState.financials != null })?.asString()
    LaunchedEffect(messageText) {
        messageText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(FinancialsEvent.MessageShown)
        }
    }

    // SH-152: the explanations name the team's people.
    CompositionLocalProvider(LocalExplainNames provides uiState.names) {
    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                // SH-89: the workplace and the month are the bar's; the bottom bar says Finances.
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    // SH-228: the sales statistics, for those who see the money (the screen's own gate).
                    val workplaceId = uiState.currentWorkplaceId
                    if (workplaceId != null && uiState.capabilities.shows(Gate.MONEY)) {
                        val month = uiState.rosters.firstOrNull { it.id == uiState.selectedRosterId }
                            ?.let { kotlinx.datetime.LocalDate(it.year, it.month, 1).toString() }
                        add(TopBarAction(
                            stringResource(Res.string.statistics_title), Icons.Default.BarChart,
                            { onNavigateToStatistics(workplaceId, month) },
                            labelled = true, collapsible = false, testTag = STATISTICS_ACTION_TAG
                        ))
                    }
                    add(helpAction(HelpPage.FINANCIALS))
                    add(notificationsAction())
                    add(TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false))
                }
            )
        }
    ) { padding ->
        val maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        Box(modifier = Modifier.fillMaxSize().padding(padding)) {
            Column(Modifier.fillMaxSize()) {
                val loadError = uiState.loadError
                if (uiState.financials == null && loadError != null) {
                    // SH-168: the month could not be read: Try again.
                    com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = { viewModel.onEvent(FinancialsEvent.Retry) })
                } else if (uiState.financials == null && !uiState.isLoading) {
                    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(uiState.error?.asString() ?: stringResource(Res.string.financials_empty))
                    }
                } else if (uiState.financials == null) {
                    // SH-247: the month's figures are on their way: the hero card, the figures and the chart's shapes.
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        FigurePlaceholder()
                        com.evoapps.evoshift.ui.adaptive.ResponsiveColumns(
                            sections = listOf(
                                { com.evoapps.evoshift.widgets.SkeletonCard(lines = 3) },
                                { com.evoapps.evoshift.widgets.SkeletonCard(lines = 3) }
                            ),
                            maxColumns = 2
                        )
                        ChartPlaceholder(plotHeight = 200.dp)
                    }
                } else {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        val widthClass = LocalWindowWidthClass.current
                        val isCompact = widthClass.isCompact

                        // SH-147: people working without pay terms leave every figure below understated.
                        uiState.selectedRosterId?.let { MissingPayBanner(MissingPayScope(it)) }

                        // 1. Primary Health Card (Combined State)
                        uiState.financials?.combined?.let { combined ->
                            // SH-191: the month's SPMH (sales per man-hour): takings and targets ÷ their hours.
                            val spmhStat: @Composable () -> Unit = {
                                FinancialStat(
                                    label = stringResource(Res.string.spmh),
                                    value = formatSpmhOrDash(uiState.spmh(Side.FORECAST), uiState.currency),
                                    color = Color.White,
                                    calculation = uiState.spmhExplained(Side.FORECAST),
                                    currency = uiState.currency
                                )
                            }
                            StandoutCard {
                                Column(modifier = Modifier.padding(16.dp)) {
                                    Text(
                                        stringResource(Res.string.financials_health),
                                        style = MaterialTheme.typography.labelMedium,
                                        color = Color.White.copy(alpha = 0.7f)
                                    )
                                    Spacer(modifier = Modifier.height(16.dp))
                                    
                                    Row(
                                        modifier = Modifier.fillMaxWidth(),
                                        horizontalArrangement = Arrangement.SpaceBetween
                                    ) {
                                        FinancialStat(
                                            label = stringResource(Res.string.revenue),
                                            value = formatMoney(combined.revenue, uiState.currency),
                                            color = Color.White,
                                            calculation = uiState.netSalesExplained(Side.FORECAST),
                                            currency = uiState.currency
                                        )
                                        // A full-width hero on a desktop has room for the cost side too.
                                        if (widthClass.isExpanded) {
                                            FinancialStat(
                                                label = stringResource(Res.string.financials_labor_costs),
                                                value = formatMoney(combined.laborCost, uiState.currency),
                                                color = Color.White,
                                                calculation = uiState.labourCostExplained(Side.FORECAST),
                                                currency = uiState.currency
                                            )
                                            FinancialStat(
                                                label = stringResource(Res.string.financials_total_expenses),
                                                value = formatMoney(combined.laborCost + combined.otherCosts, uiState.currency),
                                                color = Color.White,
                                                calculation = uiState.totalExpensesExplained(Side.FORECAST),
                                                currency = uiState.currency
                                            )
                                        }
                                        // SH-95: labour % of income (of sales without a commission), against the target.
                                        val labourPercent = combined.labourPercent
                                        val labourColor = if (labourPercent != null && uiState.labourOverTarget(labourPercent)) Color(0xFFFF6B6B) else Color(0xFF51CF66)
                                        FinancialStat(
                                            label = stringResource(labourPercentLabelRes(combined.labourBase)),
                                            value = formatPercentOrDash(labourPercent),
                                            color = labourColor,
                                            calculation = uiState.labourPercentExplained(Side.FORECAST),
                                            currency = uiState.currency
                                        )
                                        // SH-191: SPMH beside the labour % (its own row on a phone).
                                        if (!isCompact) spmhStat()
                                    }
                                    if (isCompact) {
                                        Spacer(modifier = Modifier.height(12.dp))
                                        spmhStat()
                                    }
                                    
                                    Spacer(modifier = Modifier.height(16.dp))
                                    
                                    // SH-158: the bar moves to the new labour share and shifts colour past the target.
                                    val labourShare = animatedFraction(((combined.labourPercent ?: 0.0) / 100).toFloat().coerceIn(0f, 1f))
                                    val labourBarColor by animateColorAsState(
                                        if (combined.labourPercent?.let { uiState.labourOverTarget(it) } == true) Color(0xFFFF6B6B) else Color(0xFF51CF66),
                                        motionTween(),
                                        label = "labourBar"
                                    )
                                    LinearProgressIndicator(
                                        progress = { labourShare },
                                        modifier = Modifier.fillMaxWidth().height(8.dp),
                                        color = labourBarColor,
                                        trackColor = Color.White.copy(alpha = 0.1f)
                                    )
                                }
                            }
                        }

                        // The sections below are emitted into whichever column hosts them: one long
                        // column on phones, side-by-side columns on tablets and desktops.
                        val comparison: @Composable () -> Unit = {
                            Text(
                                stringResource(Res.string.financials_comparison),
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                color = DeepNavy
                            )

                            // 2. Comparison Grid
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(12.dp)
                            ) {
                                uiState.financials?.planned?.let { planned ->
                                    ComparisonCard(
                                        modifier = Modifier.weight(1f),
                                        title = stringResource(Res.string.planned),
                                        summary = planned,
                                        currency = uiState.currency,
                                        salesCalculation = uiState.netSalesExplained(Side.PLAN),
                                        labourCalculation = uiState.labourPercentExplained(Side.PLAN),
                                        spmh = uiState.spmh(Side.PLAN),
                                        spmhCalculation = uiState.spmhExplained(Side.PLAN)
                                    )
                                }
                                uiState.financials?.actual?.let { actual ->
                                    ComparisonCard(
                                        modifier = Modifier.weight(1f),
                                        title = stringResource(Res.string.financials_actual_to_date),
                                        summary = actual,
                                        currency = uiState.currency,
                                        salesCalculation = uiState.netSalesExplained(Side.ACTUAL),
                                        labourCalculation = uiState.labourPercentExplained(Side.ACTUAL),
                                        spmh = uiState.spmh(Side.ACTUAL),
                                        spmhCalculation = uiState.spmhExplained(Side.ACTUAL)
                                    )
                                }
                            }
                            // SH-225: the sales against last week and last year.
                            uiState.salesComparison?.let { SalesComparisonChips(it) }
                        }

                        // 3. Detailed Breakdown
                        val breakdown: @Composable () -> Unit = {
                            RegularCard {
                                Column(modifier = Modifier.padding(16.dp)) {
                                    Text(
                                        stringResource(Res.string.financials_cost_breakdown),
                                        style = MaterialTheme.typography.titleSmall,
                                        fontWeight = FontWeight.Bold
                                    )
                                    Spacer(modifier = Modifier.height(12.dp))
                                    
                                    BreakdownRow(
                                        stringResource(Res.string.financials_labor_costs),
                                        formatMoney(uiState.financials?.combined?.laborCost ?: 0.0, uiState.currency),
                                        calculation = uiState.labourCostExplained(Side.FORECAST),
                                        currency = uiState.currency
                                    )
                                    BreakdownRow(
                                        stringResource(Res.string.financials_other_costs),
                                        formatMoney(uiState.financials?.combined?.otherCosts ?: 0.0, uiState.currency),
                                        calculation = uiState.otherCostsExplained(Side.FORECAST),
                                        currency = uiState.currency
                                    )
                                    
                                    HorizontalDivider(
                                        modifier = Modifier.padding(vertical = 8.dp),
                                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.1f)
                                    )
                                    
                                    BreakdownRow(
                                        label = stringResource(Res.string.financials_total_expenses),
                                        value = formatMoney((uiState.financials?.combined?.laborCost ?: 0.0) + (uiState.financials?.combined?.otherCosts ?: 0.0), uiState.currency),
                                        isBold = true,
                                        calculation = uiState.totalExpensesExplained(Side.FORECAST),
                                        currency = uiState.currency
                                    )
                                    // A planning figure, not the pay run (SH-56).
                                    Spacer(modifier = Modifier.height(8.dp))
                                    Text(
                                        stringResource(Res.string.financials_estimate_note),
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                                    )
                                    // SH-147: what the labour cost here counts, against the labour cost screen.
                                    Spacer(modifier = Modifier.height(4.dp))
                                    Text(
                                        stringResource(Res.string.financials_labor_costs_note),
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                                    )
                                }
                            }
                        }

                        // Daily Records and Labour cost buttons; [buttonModifier] sizes each one.
                        val navigationButtons: @Composable (buttonModifier: Modifier) -> Unit = { buttonModifier ->
                            uiState.selectedRosterId?.let { rosterId ->
                                val workplaceId = uiState.rosters.find { it.id == rosterId }?.workplaceId
                                if (workplaceId != null) {
                                    Button(
                                        onClick = { onNavigateToDailyRecords(workplaceId, rosterId) },
                                        modifier = buttonModifier.handCursor(),
                                        colors = ButtonDefaults.buttonColors(
                                            containerColor = DeepNavy
                                        ),
                                        shape = RoundedCornerShape(12.dp)
                                    ) {
                                        Text(stringResource(Res.string.financials_show_daily_records), color = Color.White)
                                        Spacer(Modifier.width(8.dp))
                                        Icon(Icons.Default.ChevronRight, null, tint = Color.White)
                                    }
                                    // SH-257: confirming the actual hours, day by day.
                                    if (uiState.capabilities.shows(Gate.WORK_HOURS)) Button(
                                        onClick = { onNavigateToWorkHours(workplaceId) },
                                        modifier = buttonModifier.handCursor().testTag(FINANCIALS_WORK_HOURS_TAG),
                                        colors = ButtonDefaults.buttonColors(containerColor = DeepNavy),
                                        shape = RoundedCornerShape(12.dp)
                                    ) {
                                        Text(stringResource(Res.string.work_hours_title), color = Color.White)
                                        Spacer(Modifier.width(8.dp))
                                        Icon(Icons.Default.ChevronRight, null, tint = Color.White)
                                    }
                                    if (uiState.capabilities.shows(Gate.PAYROLL)) Button(
                                        onClick = { onNavigateToPayroll(rosterId) },
                                        modifier = buttonModifier.handCursor(),
                                        colors = ButtonDefaults.buttonColors(containerColor = DeepNavy),
                                        shape = RoundedCornerShape(12.dp)
                                    ) {
                                        Text(stringResource(Res.string.financials_show_payroll), color = Color.White)
                                        Spacer(Modifier.width(8.dp))
                                        Icon(Icons.Default.ChevronRight, null, tint = Color.White)
                                    }
                                }
                            }
                        }

                        // SH-46: the month's result, plan against actual (the "Wynik Finansowy" sheet).
                        val monthlyResult: @Composable () -> Unit = {
                            uiState.monthlyResult?.let {
                                MonthlyResultCard(it, uiState.currency, explained = { side -> uiState.resultExplained(side) })
                            }
                        }

                        // SH-115: the labour budget against the planned and actual labour cost (when set).
                        val labourBudget: @Composable () -> Unit = {
                            uiState.budgetComparison?.let { com.evoapps.evoshift.ui.roster.BudgetComparisonCard(it, uiState.currency) }
                        }

                        // 4. The month's costs: the rules' and the one-off expenses (SH-84), which
                        // money editors add here. Read-only once the plan ended (SH-65).
                        val costs = uiState.costs
                        val canEditCosts = uiState.capabilities.shows(Gate.MONEY_EDITING) && uiState.selectedRosterId != null
                        val showCosts = costs.isNotEmpty() || canEditCosts
                        val fixedCosts: @Composable () -> Unit = {
                            MonthCostsSection(
                                costs = costs,
                                currency = uiState.currency,
                                canEdit = canEditCosts,
                                onAdd = { addingCost = true },
                                onEdit = { editingCost = it },
                                onDelete = { deletingCost = it }
                            )
                        }

                        if (isCompact) {
                            monthlyResult()
                            labourBudget()
                            comparison()
                            breakdown()
                            navigationButtons(Modifier.fillMaxWidth())
                            if (showCosts) fixedCosts()
                        } else {
                            // Wide windows: the two reports as an action bar under the hero, then the
                            // comparison with the month's result, the breakdown and the fixed costs as columns.
                            if (uiState.selectedRosterId != null) {
                                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                                    navigationButtons(Modifier.weight(1f))
                                }
                            }
                            val sections = buildList<@Composable () -> Unit> {
                                // The result table under the plan / actual cards it details (SH-46).
                                add { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { comparison(); monthlyResult() } }
                                add { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { labourBudget(); breakdown() } }
                                if (showCosts) add { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { fixedCosts() } }
                            }
                            ResponsiveColumns(sections = sections, maxColumns = sections.size)
                        }
                    }
                }
            }

            // Only over an empty screen; switching month or workplace keeps the figures until the new ones arrive.
            // SH-247: the first load shows the placeholders above (no spinner).

        }
    }
    }

    // --- One-off expenses of the month (SH-84) ---
    val roster = uiState.rosters.find { it.id == uiState.selectedRosterId }
    if (roster != null && (addingCost || editingCost != null)) {
        val cost = editingCost
        OneOffCostDialog(
            year = roster.year,
            month = roster.month,
            currency = uiState.currency,
            cost = cost,
            defaultDay = today(),
            onDismiss = { addingCost = false; editingCost = null },
            onSave = { input ->
                viewModel.onEvent(FinancialsEvent.SaveOneOffCost(input, editingId = cost?.id))
                addingCost = false
                editingCost = null
            }
        )
    }
    deletingCost?.let { cost ->
        DeleteOneOffCostDialog(
            cost = cost,
            onConfirm = {
                viewModel.onEvent(FinancialsEvent.DeleteOneOffCost(cost.id))
                deletingCost = null
            },
            onDismiss = { deletingCost = null }
        )
    }
}

private fun today(): LocalDate = AppClock.todayIn(TimeZone.currentSystemDefault())

@Composable
fun ComparisonCard(
    modifier: Modifier = Modifier,
    title: String,
    summary: FinancialSummary,
    currency: String,
    /** SH-152: how the net sales and the labour % were worked out (tap to see). */
    salesCalculation: Calculation? = null,
    labourCalculation: Calculation? = null,
    /** SH-191: the side's SPMH (sales per man-hour) and how it was worked out; null: "-". */
    spmh: Double? = null,
    spmhCalculation: Calculation? = null
) {
    RegularCard(modifier = modifier) {
        Column(modifier = Modifier.padding(12.dp)) {
            Text(title, style = MaterialTheme.typography.labelSmall, color = DeepNavy.copy(alpha = 0.6f))
            Spacer(modifier = Modifier.height(4.dp))
            ExplainableAmount(formatMoney(summary.revenue, currency), salesCalculation, currency, fontWeight = FontWeight.Bold, style = LocalTextStyle.current.copy(fontSize = 16.sp))
            ExplainableAmount(
                stringResource(labourValueRes(summary.labourBase), formatPercentOrDash(summary.labourPercent)),
                labourCalculation, currency, style = MaterialTheme.typography.bodySmall
            )
            ExplainableAmount(
                stringResource(Res.string.spmh) + " " + formatSpmhOrDash(spmh, currency),
                spmhCalculation.takeIf { spmh != null }, currency, style = MaterialTheme.typography.bodySmall
            )
        }
    }
}

@Composable
fun FinancialStat(label: String, value: String, color: Color, calculation: Calculation? = null, currency: String = "") {
    Column {
        // The label in the surface's secondary colour: the figure's green faded to 70% was 3.3:1 on the navy.
        Text(label, style = MaterialTheme.typography.labelSmall, color = LocalOnColours.current.onSurfaceVariant)
        ExplainableAmount(value, calculation, currency, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = color, animated = true)
    }
}

@Composable
fun BreakdownRow(label: String, value: String, isBold: Boolean = false, calculation: Calculation? = null, currency: String = "") {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        val style = if (isBold) MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold) else MaterialTheme.typography.bodyMedium
        Text(label, style = style)
        ExplainableAmount(value, calculation, currency, style = style, animated = true)
    }
}

/** SH-228: the Money screen's "Statystyki" in the bar. */
const val STATISTICS_ACTION_TAG = "statistics_action"

/** SH-257: the "Godziny pracy" button. */
const val FINANCIALS_WORK_HOURS_TAG = "financials_work_hours"
